
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/submit",
      function () {
        return require("private-next-pages/[locale]/submit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/submit"])
      });
    }
  